<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row" :gutter="24">
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="名称">
            <a-input :disabled="params.isShow" placeholder="请输入名称" v-decorator="[
          'name',
          {initialValue:data.name,rules: [{ required: true, message: '请输入名称' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="代码">
            <a-input :disabled="params.isShow" placeholder="请输入代码" v-decorator="[
          'code',
          {initialValue:data.code,rules: [{ required: false, message: '请输入代码' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人">
            <a-input :disabled="params.isShow" placeholder="请输入联系人" v-decorator="[
          'contact',
          {initialValue:data.name,rules: [{ required: true, message: '请输入联系人' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话">
            <a-input :disabled="params.isShow" placeholder="请输入联系电话" v-decorator="[
          'telephone',
          {initialValue:data.name,rules: [{ required: true, message: '请输入联系电话' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地址">
            <a-cascader :disabled="this.params.isShow" :options="addressOptions" expandTrigger="hover" @change="changeAddressdata" placeholder="请选择地址" v-decorator="[
          'defaultValue',
          {initialValue:defaultValue,rules: [{ required: true, message: '请选择地址' }]}]" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="详细地址">
            <a-input :read-only="this.params.isShow" placeholder="请输入详细地址" v-decorator="[
          'address',
          {initialValue:data.address,rules: [{ required: true, message: '请输入详细地址' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>

      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label="">
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
const defaultData = {
  id: 0,
  name: "",
  code: "",
  contact: "",
  telephone: "",
  provinceId: "",
  cityId: "",
  districtId: "",
  address: "",
  isActive: 1
};
export default {
  name: "hp-manager-page-Organization-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      addressOptions: config.addressJson,
      defaultValue: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    };
  },

  async mounted() {
    if (this.params.id) {
      // this.data = Object.assign(this.params,defaultData)
      this.getDetailOrganization();
    } else {
      this.data = exzends(defaultData);
    }
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    async getDetailOrganization() {
      this.loading = true;
      let result = await api.GetOrganization({
        organizationId: this.params.id
      });
      if (result) {
        this.data = result;
        this.defaultValue = [
          this.data.provinceId + "",
          this.data.cityId + "",
          this.data.districtId + ""
        ];
      }
      console.log(this.defaultValue);
      this.loading = false;
    },
    async submitHandler() {
      await api.AddOrUpdateOrganization(requestData);
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        name: value.name,
        code: value.code,
        contact: value.contact,
        telephone: value.telephone,
        provinceId: this.data.provinceId,
        cityId: this.data.cityId,
        districtId: this.data.districtId,
        address: value.address
      };
      return result;
    },
    changeAddressdata(option) {
      console.log(option);
      this.data.provinceId = parseInt(option[0]);
      this.data.cityId = parseInt(option[1]);
      if (option[2]) {
        this.data.districtId = option[2];
      }
      console.log(this.form);
      this.form.setFieldsValue({
        provinceId: this.data.provinceId
      });
    },
    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });
      if (!valid.err) {
        let data;
        let requestData = this.dataToPostData(valid.values);
        if (this.params.id > 0) {
          data = await api.AddOrUpdateOrganization(requestData);
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          data = await api.AddOrUpdateOrganization(requestData);
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
        console.log(requestData);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Basic/Organization/Add.vue